module.exports = __webpack_public_path__ + "teqbahn-assets/media/blog9.a227a11c.jpeg";